function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  id: "export-badges",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "production",
  transform: "translate(-608.000000, -288.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "card_master",
  transform: "translate(608.000000, 288.000000)"
}, /*#__PURE__*/React.createElement("rect", {
  id: "bg",
  fill: "#FFFFFF",
  x: 0,
  y: 0,
  width: 120,
  height: 80,
  rx: 4
}), /*#__PURE__*/React.createElement("g", {
  id: "logo",
  transform: "translate(22.000000, 16.000000)"
}, /*#__PURE__*/React.createElement("polygon", {
  id: "Fill-2",
  fill: "#FF5F00",
  points: "28.0135314 42.5734984 48.7093014 42.5734984 48.7093014 5.38287122 28.0135314 5.38287122"
}), /*#__PURE__*/React.createElement("path", {
  d: "M29.3275486,23.9788418 C29.3275486,16.4337554 32.8602837,9.71387171 38.3614164,5.38287122 C34.3385529,2.21608991 29.2618477,0.32653326 23.7442897,0.32653326 C10.6823023,0.32653326 0.0939522256,10.9155404 0.0939522256,23.9788418 C0.0939522256,37.0414862 10.6823023,47.6304933 23.7442897,47.6304933 C29.2618477,47.6304933 34.3385529,45.7409367 38.3614164,42.5741554 C32.8602837,38.2431549 29.3275486,31.5232712 29.3275486,23.9788418",
  id: "Fill-3",
  fill: "#EB001B"
}), /*#__PURE__*/React.createElement("path", {
  d: "M75.890403,38.634732 L75.890403,37.716891 L75.6505948,37.716891 L75.3753082,38.3482762 L75.0993646,37.716891 L74.8595565,37.716891 L74.8595565,38.634732 L75.0290647,38.634732 L75.0290647,37.9422449 L75.2872691,38.5394657 L75.4626904,38.5394657 L75.7215518,37.9409309 L75.7215518,38.634732 L75.890403,38.634732 Z M74.3727132,38.634732 L74.3727132,37.873259 L74.6795362,37.873259 L74.6795362,37.718205 L73.897696,37.718205 L73.897696,37.873259 L74.204519,37.873259 L74.204519,38.634732 L74.3727132,38.634732 L74.3727132,38.634732 Z",
  id: "Fill-4",
  fill: "#F79E1B"
}), /*#__PURE__*/React.createElement("path", {
  d: "M76.6288806,23.9788418 C76.6288806,37.0414862 66.0405305,47.6304933 52.9785431,47.6304933 C47.4609851,47.6304933 42.3842799,45.7409367 38.3614164,42.5741554 C43.8625492,38.2431549 47.3952843,31.5232712 47.3952843,23.9788418 C47.3952843,16.4337554 43.8625492,9.71387171 38.3614164,5.38287122 C42.3842799,2.21608991 47.4609851,0.32653326 52.9785431,0.32653326 C66.0405305,0.32653326 76.6288806,10.9155404 76.6288806,23.9788418",
  id: "Fill-5",
  fill: "#F79E1B"
})))));

function SvgMastercard({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "120px",
    height: "80px",
    viewBox: "0 0 120 80",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref);
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMastercard);
export default __webpack_public_path__ + "static/media/mastercard.6ff14f70.svg";
export { ForwardRef as ReactComponent };